import { Box, SubjectBreadcrumbs } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoSubject_TodoSubject$key } from "./__generated__/TodoSubject_TodoSubject.graphql";
import { TodoSubjectIcon } from "./TodoSubjectIcon";

import { TodoSubjectExcludeRoot_TodoSubject$key } from "./__generated__/TodoSubjectExcludeRoot_TodoSubject.graphql";

export function TodoSubjectExcludeRoot(props: {
  subject: TodoSubjectExcludeRoot_TodoSubject$key;
  trailingBreadcrumb?: string;
  placeholder?: string;
  onlyRequired?: boolean;
}) {
  const subject = useFragment(
    graphql`
      fragment TodoSubjectExcludeRoot_TodoSubject on TodoSubject {
        allBreadcrumbs {
          title
          isRoot
          requiredToDescribeTodo
        }
      }
    `,
    props.subject
  );

  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
      spaceRight="xsmall"
    >
      <SubjectBreadcrumbs
        highlightLast
        breadcrumbs={subject.allBreadcrumbs
          .filter(
            (a) =>
              !a.isRoot && (!props.onlyRequired || a.requiredToDescribeTodo)
          )
          .map((s) => s.title)}
        trailingBreadcrumb={props.trailingBreadcrumb}
        placeholder={props.placeholder}
      />
    </Box>
  );
}

export function TodoSubject(props: {
  subject: TodoSubject_TodoSubject$key;
  trailingBreadcrumb?: string;
  highlightLast?: boolean;
  onlyRequired?: boolean;
}) {
  const subject = useFragment(
    graphql`
      fragment TodoSubject_TodoSubject on TodoSubject {
        allBreadcrumbs {
          title
          requiredToDescribeTodo
        }
        ...TodoSubjectIcon_TodoSubject
      }
    `,
    props.subject
  );

  const highlightLast = props.highlightLast || !!props.trailingBreadcrumb;

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
      }}
      spaceRight="xsmall"
    >
      <TodoSubjectIcon subject={subject} />
      <SubjectBreadcrumbs
        breadcrumbs={subject.allBreadcrumbs
          .filter((a) => !props.onlyRequired || a.requiredToDescribeTodo)
          .map((s) => s.title)}
        trailingBreadcrumb={props.trailingBreadcrumb}
        highlightLast={highlightLast}
      />
    </Box>
  );
}
